import { idBuilder } from './id.utils';
import { objectUtils } from './objects/objects.utils';
import { pathUtils } from './paths/path.utils';
import { urlUtils } from './urls.utils';
import { assertionUtils } from './assertion.utils';
import { mergeUtils } from './merge.utils';
import { arrayUtils } from './arrays/arrays.utils';
import { normalize } from './normalize/normalize.utils';
import { stringUtils } from './strings/string.utils';
import {toProp} from './paths';
export const arr = arrayUtils;
export const obj = objectUtils;
export const url = urlUtils;
export const path = pathUtils;
export const ids = idBuilder();
export const assert = assertionUtils;
export const merge = mergeUtils;
export const str = stringUtils;
export module paths {}
export const di = {
  arr,
  obj,
  url,
  path,
  ids,
  assert,
  merge,
  normalize,
  str,
};
